import { createAbsoluteUrl } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import {
  Box,
  ContentBlock,
  Columns,
  Column,
  Stack,
  ButtonLink,
} from 'braid-design-system';

import { useConfig } from 'src/hooks/context';
import { getCountryFromSite } from 'src/utils/getCountryFromSite';
import TrackingLink from 'src/views/shared/TrackingLink/TrackingLink';

import translations from './.vocab';
import TatsoiTextSvg from './images/TatsoiTextSvg';
import WalterSvg from './images/WalterSvg';

interface Props {
  id: string;
}

const MarketingBanner = ({ id }: Props) => {
  const { site, locale } = useConfig();
  const country = getCountryFromSite(site);
  const trackingUrl = createAbsoluteUrl({
    product: 'employer',
    country,
    language: locale,
    path: '/products/adcentre/?tracking=SEK-SAU-BAN-TATSOIHirer-30409&o[…]ource=SEEK&onsite_medium=Display&onsite_content=TATSOIHirer',
  });
  const { t } = useTranslations(translations);

  return (
    <Box
      id={id}
      paddingTop={['large', 'none']}
      paddingBottom="none"
      paddingX="gutter"
      style={{
        backgroundColor: '#96dccf',
      }}
    >
      <ContentBlock>
        <Columns
          space={['gutter', 'none']}
          collapseBelow="tablet"
          alignY="center"
        >
          <Column>
            <Stack space="medium">
              <Box>
                <TatsoiTextSvg />
              </Box>
              <Box display="flex" justifyContent="center">
                <Box>
                  <TrackingLink
                    renderAs={ButtonLink}
                    id={id}
                    href={trackingUrl}
                    data-analytics-origin={id}
                  >
                    {t('Marketing banner learn more button')}
                  </TrackingLink>
                </Box>
              </Box>
            </Stack>
          </Column>
          <Column>
            <Box paddingTop={['none', 'xlarge']}>
              <WalterSvg />
            </Box>
          </Column>
        </Columns>
      </ContentBlock>
    </Box>
  );
};

export default MarketingBanner;
